import React, { useEffect, useState } from "react";
import api from "../api";
import { useParams, useNavigate } from "react-router-dom";

export default function CustomerEdit() {

  const { id } = useParams();
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    email: "",
    company_name: "",
    phone: "",
    address: ""
  });

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const fetchCustomer = async () => {
      try {
        const res = await api.get(`/customers/${id}`);
        const c = res.data;

        setForm({
          name: c.user?.name || "",
          email: c.user?.email || "",
          company_name: c.company_name || "",
          phone: c.phone || "",
          address: c.address || ""
        });

      } catch {
        alert("Failed to load customer");
      } finally {
        setLoading(false);
      }
    };

    fetchCustomer();
  }, [id]);

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      setSaving(true);
      await api.put(`/customers/${id}`, form);
      alert("Customer updated");
      navigate("/customers");
    } catch (err) {
      alert("Update failed");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="container mt-3">Loading...</div>;
  }

  return (
    <div className="container mt-3">

      {/* 🔥 CENTER WRAPPER */}
      <div className="mx-auto" style={{ maxWidth: "600px" }}>

        <div className="card p-3 shadow-sm">

          <h4 className="mb-3">✏️ Edit Customer</h4>

          <form onSubmit={handleSubmit}>

            {/* NAME */}
            <div className="mb-3">
              <label className="form-label">Name</label>
              <input
                name="name"
                className="form-control"
                value={form.name}
                onChange={handleChange}
              />
            </div>

            {/* EMAIL */}
            <div className="mb-3">
              <label className="form-label">Email</label>
              <input
                type="email"
                name="email"
                className="form-control"
                value={form.email}
                onChange={handleChange}
                required
              />
            </div>

            {/* COMPANY */}
            <div className="mb-3">
              <label className="form-label">Company</label>
              <input
                name="company_name"
                className="form-control"
                value={form.company_name}
                onChange={handleChange}
              />
            </div>

            {/* PHONE */}
            <div className="mb-3">
              <label className="form-label">Phone</label>
              <input
                name="phone"
                className="form-control"
                value={form.phone}
                onChange={handleChange}
              />
            </div>

            {/* ADDRESS */}
            <div className="mb-3">
              <label className="form-label">Address</label>
              <textarea
                name="address"
                className="form-control"
                value={form.address}
                onChange={handleChange}
              />
            </div>

            {/* DESKTOP BUTTONS */}
            <div className="d-none d-md-flex justify-content-between">
              <button
                type="submit"
                className="btn btn-success px-4"
                disabled={saving}
              >
                {saving ? "Updating..." : "Update"}
              </button>

              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => navigate("/customers")}
              >
                Cancel
              </button>
            </div>

          </form>

        </div>

      </div>

      {/* 🔥 MOBILE STICKY BUTTON */}
      <div className="d-md-none fixed-bottom bg-white p-2 border-top shadow">
        <button
          className="btn btn-success w-100"
          onClick={handleSubmit}
          disabled={saving}
        >
          {saving ? "Updating..." : "Update Customer"}
        </button>
      </div>

      {/* spacing */}
      <div className="d-md-none" style={{ height: "70px" }}></div>

    </div>
  );
}